/**
 * 全局配置
 */
const {
    VUE_APP_ENV,
    VUE_APP_CDN_URL,
    VUE_APP_MAIN_SITE_URL,
    VUE_APP_BASE_API,
    VUE_APP_YQ_QUESTION,
    VUE_APP_YQ_SITE_URL,
    VUE_APP_UCENTER_SITE,
    VUE_APP_YAO_SITE_URL,
    VUE_APP_YQ_CONTENT_DOMAIN,
} = process.env;
export const ENV = VUE_APP_ENV; // 环境
export const CDN = window.static_cdn || VUE_APP_CDN_URL; //cdn
export const YQ_QUESTION = VUE_APP_YQ_QUESTION; //17QUESTION
export const axiosConfig = {
    ucenterSiteDomain: VUE_APP_ENV === 'development' ? '' : VUE_APP_UCENTER_SITE,
    mainSiteDomain: VUE_APP_MAIN_SITE_URL,
    baseUrl: VUE_APP_ENV === 'development' ? '/' : VUE_APP_MAIN_SITE_URL,
    schoolUrl: VUE_APP_ENV === 'development' ? '/SCHOOL_API' : VUE_APP_BASE_API,
    YQUrl: VUE_APP_ENV === 'development' ? '/' : VUE_APP_YQ_SITE_URL,
    YaoUrl: VUE_APP_ENV === 'development' ? '/' : VUE_APP_YAO_SITE_URL,
    yqContentDomain: VUE_APP_ENV === 'development' ? '/' : VUE_APP_YQ_CONTENT_DOMAIN,
    timeout: 10 * 1000,
};
export const ceresConfig = {
    js: YQ_QUESTION + '/s17/lib/ceres/2.1.5/ceres.umd.js',
    css: YQ_QUESTION + '/s17/lib/ceres/2.1.5/style.css',
    vue: YQ_QUESTION + '/s17/lib/vue/3.2.38/vue.global.prod.js',
};
